import { useInjectedScript } from 'sidecar-utilities'

/**
 * This hook is used to inject the AccessiBe script into the app. This script
 * will take care of loading in the AccessiBe widget. Its settings come from the
 * accessiBe dashboard, which overrides anything passed to `acsbJS.init`, so we
 * pass nothing. The vendor trigger is hidden in sidecar-design's index.css and
 * the panel opens from our own trigger instead. This functionality is hidden
 * behind a feature flag.
 *
 * @returns Void
 */
const showAccessibe = process.env.SHOW_ACCESSIBE

// Module scope keeps this config stable across renders, because
// useInjectedScript re-runs its effect, and with it the callback, whenever the
// config object changes.
const accessibeScript = {
  id: 'accessibeScript',
  src: 'https://acsbapp.com/apps/app/dist/js/app.js',
  callback: () => window.acsbJS?.init(),
}

export const useAccessibe = () => {
  if (!showAccessibe) return

  // accessibe won't load on local, so just bail to avoid errors
  if (process.env.NODE_ENV !== 'production') return

  useInjectedScript(accessibeScript)
}
